const PARTY_COLORS = [
  '#ff6b9d', '#ffd93d', '#6bcb77', '#4d96ff', '#9b59b6',
  '#ff8fab', '#f4a261', '#e9c46a', '#2a9d8f', '#f72585',
];

function createPieces(count, width, height) {
  return Array.from({ length: count }, () => ({
    x: Math.random() * width,
    y: -20 - Math.random() * height * 0.5,
    w: 5 + Math.random() * 9,
    h: 8 + Math.random() * 16,
    color: PARTY_COLORS[Math.floor(Math.random() * PARTY_COLORS.length)],
    rotation: Math.random() * Math.PI * 2,
    spin: (Math.random() - 0.5) * 0.25,
    vx: (Math.random() - 0.5) * 4,
    vy: 2.5 + Math.random() * 5,
    opacity: 0.85 + Math.random() * 0.15,
  }));
}

/**
 * Lightweight party-paper confetti burst — no dependencies.
 */
export function blastPartyPaper({ durationMs = 3000, pieceCount = 140 } = {}) {
  if (typeof window === 'undefined') return;

  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = [
    'position:fixed',
    'inset:0',
    'width:100%',
    'height:100%',
    'pointer-events:none',
    'z-index:99999',
  ].join(';');

  const width = window.innerWidth;
  const height = window.innerHeight;
  canvas.width = width;
  canvas.height = height;
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  const pieces = createPieces(pieceCount, width, height);
  const burstX = width * 0.5;
  const burstY = height * 0.35;
  const start = performance.now();

  const frame = (now) => {
    const elapsed = now - start;
    if (elapsed > durationMs) {
      canvas.remove();
      return;
    }

    ctx.clearRect(0, 0, width, height);

    pieces.forEach((piece) => {
      const progress = elapsed / durationMs;
      piece.x += piece.vx;
      piece.y += piece.vy;
      piece.vy += 0.06;
      piece.rotation += piece.spin;

      if (elapsed < 400) {
        piece.x += (burstX - piece.x) * 0.02;
        piece.y += (burstY - piece.y) * 0.02;
      }

      ctx.save();
      ctx.globalAlpha = piece.opacity * (1 - progress * 0.35);
      ctx.translate(piece.x, piece.y);
      ctx.rotate(piece.rotation);
      ctx.fillStyle = piece.color;
      ctx.fillRect(-piece.w / 2, -piece.h / 2, piece.w, piece.h);
      ctx.restore();
    });

    requestAnimationFrame(frame);
  };

  requestAnimationFrame(frame);
}
